import { Dayjs } from 'dayjs'
import {
  type S3Object as GQLS3Object,
  type Location as GQLLocation
} from '../graphql/types'

export type S3Object = Omit<GQLS3Object, '__typename'>

export interface IStorageObject {
  readonly s3Object: S3Object
  deleteFile: () => Promise<void>
  getPublicUrl: () => Promise<string>
}

export interface IDateRange {
  startDate: Date
  endDate: Date
}

export interface IDayJSRange {
  startDate: Dayjs
  endDate: Dayjs
}

export interface Time {
  hour: number
  minute: number
}

// No timezone associated with this time range
export interface TimeRange {
  startTime: Time
  endTime: Time
}

export enum Weekday {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export type Location = Omit<GQLLocation, '__typename'>

export interface GetByLocationInput {
  // Can be zip code, city, state, etc
  // can get lat and long from google maps api
  //    https://developers.google.com/maps/documentation/geocoding/overview
  locationString: string
}

export interface IPaginatedList<T> {
  items: T[]
  nextToken?: string
}

export interface IPagination {
  limit: number
  nextToken?: string
}

export enum Timezone {
  NEW_YORK = 'America/New_York',
  CHICAGO = 'America/Chicago',
  DENVER = 'America/Denver',
  LOS_ANGELES = 'America/Los_Angeles',
}
